import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"

export interface IPagination {
    page: number;
    limit: number;
    keyword: string;
    status?: string;
    sort_by?: string;
    sort_order?: string;
}

export const adminDashboardCountApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminDashboardNew)
    return response
}

export const adminUserDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminUserData)
    return response
}

export const adminUserPaginationDataApi = async (data: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.adminUserPaginationData, data)
    return response
}

export const adminBusinessDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminBusinessData)
    return response
}

export const adminBusinessPaginationDataApi = async (data: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.adminBusinessPaginationData, data)
    return response
}

export const adminScansDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminScanData)
    return response
}

export const adminScanPaginationDataApi = async (data: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.adminScanPaginationData, data)
    return response
}

export const adminConfigurationDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminConfigurationData)
    return response
}

export const adminCtrBoosterApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminCtrsBoosterData)
    return response
}

export const adminPlansDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminPlansData)
    return response
}

export const adminUserListSimplifiedApi = async (data: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.adminUserListSimplified, data)
    return response
}

export const adminBusinessListSimplifiedApi = async (data: { userId: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.adminBusinessListSimplified, data)
    return response
}

export const getAdminManagerListApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.getAdminManagerList)
    return response
}

export const deleteAdminManagerApi = async (data: { id: string | null }) => {
    const response = await AxiosInstance.post(apiRoutes?.deleteManager, data)
    return response
}

export const addAdminManagerApi = async (data: any) => {
    const response = await AxiosInstance.post(apiRoutes?.addAdminManager, data)
    return response
}

export const adminWorkspaceDeletePreviewApi = async (data: { userId: string; workspaceId: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.adminWorkspaceDeletePreview, data);
    return response;
}

export const adminWorkspaceDeleteApi = async (data: { userId: string; workspaceId: string; force?: boolean }) => {
    const response = await AxiosInstance.post(apiRoutes?.adminWorkspaceDelete, data);
    return response;
}